
import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import Invoice from '@/models/Invoice'
import ViewModel from '@/models/ViewModel'
import WebMessage from '@/models/WebMessage'
import IconAction from '@/components/IconAction/IconAction.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import { currencyMask } from '@/models/interface/Masks'
// @ts-ignore
import { VueMaskDirective } from 'v-mask'
import FormInput from '@/components/FormInput/FormInput.vue'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import moment from 'moment'
import FaqModal from '@/components/FaqModal/FaqModal.vue'
import Tenant from '@/models/Tenant'
import home_table_options from './tenant-home-fields'

Vue.directive('mask', VueMaskDirective)
@Component({
  components: {
    Widget,
    IconAction,
    SearchInput,
    DataTable,
    FormInput,
    DatePicker,
    SelectPicker,
    FaqModal,
  },
})
export default class TenantHome extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  public show_filter_helper: boolean = false

  public page_size: number = 25

  public page: number = 1

  public records: number = 0

  public shared_data: number = 0

  public loading: boolean = false

  public ready: boolean = false

  public selected: string[] = []

  public temp_tenant: Tenant = new Tenant()

  private channel: any = null

  public selected_to_delete: any = {
    delete_tenant: false,
    delete_domain: false,
    delete_database: false,
  }

  public get list_of_deletables() {
    return [
      {
        name: 'tenant',
        description: 'Delete Tenant lorem ipsum dolor sit amet',
        value: 'tenant',
      },
      {
        name: 'domain',
        description: 'Delete Domain dorian ipsum dolor sit amet',
        value: 'domain',
      },
      {
        name: `database ${
          this.temp_tenant.database_settings.tenancy_db_name
            ? `(${this.temp_tenant.database_settings.tenancy_db_name})`
            : ''
        }`,
        description: 'Delete Database bororian ipsum <strong>dolor</strong> sit amet',
        value: 'database',
      },
    ]
  }

  public fieldFilters: any = {
    created_at: '',
    due_at: '',
    updated_at: '',
  }

  public query: string[] = []

  public fields: Array<any> = []

  public action_acknowledged: boolean = false

  public download_formats: string[] = ['pdf', 'txt']

  public filter_mode: string = 'exclusive'

  @Watch('filter_mode')
  public onFilterModeChange() {
    this.refresh()
  }

  public tenants: Tenant[] = []

  public sortDesc!: any

  public sortBy!: any

  public modal: any = {
    delete: false,
    history: false,
  }

  public query_settings: any = {
    custom_fields: [
      {
        name: 'status:active',
        value: 'is:active',
        description: 'All active Publishers(tenants)',
      },

      {
        name: 'has:errors',
        value: 'has:errors',
        description: 'Tenants with issues',
      },
    ],
  }

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public get masks() {
    return { currencyMask }
  }

  public rows(context: any) {
    this.loading = true

    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)

    this.syncFilters()
    this.getOverview()

    return Tenant.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.selected = []
      this.records = result.records
      this.shared_data = result.shared_data
      this.loading = false
      this.ready = true
      this.tenants = result.data
      return this.tenants
    })
  }

  public download(invoice: Invoice) {}

  public confirmDownload() {}

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('tenants').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
      this.ready = true
    })
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'tenants',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'tenants',
      data: null,
    })
  }

  // Reset filters
  public resetFilters() {
    this.fieldFilters = {}
    this.query = []
    this.filter_mode = 'exclusive'
    this.clearFilters()
    this.dataTable.refresh()
  }

  public loadEcho() {
    if (this.channel) {
      Vue.prototype.$echo.private(`tenant-status.${this.user.id}`).stopListening('TenantStatus')
      this.channel = null
    }

    this.channel = Vue.prototype.$echo
      .channel(`tenant-status.${this.user.id}`) // must be tenant name
      .listen('TenantStatus', (e: any) => {
        let index = this.tenants.findIndex((t: Tenant) => t.id === e.tenant_id)

        if (index >= 0) {
          const copy = [...this.tenants]
          copy[index].status = e.status
          this.tenants = copy
        }
      })
  }

  public mounted() {
    this.fields = home_table_options
    this.loadFilters()
    setTimeout(() => {
      this.loadEcho()
    }, 3000)
  }

  public getOverview() {
    // Invoice.getOverview().then((result: any) => {
    //   this.overview = result
    // })
    // console.log('checking Overview')
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public deleteTenant(tenant: any) {
    this.temp_tenant = tenant
    setTimeout(() => {
      this.modal.delete = true
    }, 300)
  }

  public resetDeletion() {
    this.selected_to_delete = {
      delete_tenant: false,
      delete_domain: false,
      delete_database: false,
    }
    this.action_acknowledged = false
  }

  public confirmDeleteTenant() {
    this.loading = true
    this.temp_tenant
      .deleteOnDemand({ ...this.selected_to_delete, confirmed: this.action_acknowledged })
      .then(() => {
        this.modal.delete = false
        this.loading = false
        this.dataTable.refresh()
        this.resetDeletion()
        setTimeout(() => {
          this.refresh()
        }, 1000)
      })
  }

  public status_color: any = {
    'creating-database': 'warning',
    'database-created': 'info',
    migrating: 'warning',
    migrated: 'success',
    seeding: 'info',
    active: 'success',
    queued_for_creation: 'warning',
  }
}
